import React from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {
    FormControl,
    FormLabel,
    FormHelperText,
    TextField,
    CircularProgress,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import get from 'lodash.get';
import {toSnakeCase} from '../locale/utils';

const AutocompleteSelect = ({
    children,
    name,
    label,
    options,
    loading,
    required,
    getOptionLabel,
    boxtext,
    onChangeListener,
    disabled,
    ...props
}) => {
    const {control, errors} = useFormContext();
    const error = get(errors, name);

    return (
        <FormControl fullWidth error={!!error}>
            <FormLabel required={required}>{label}</FormLabel>
            <Controller
                render={rProps => (
                    <Autocomplete
                        {...props}
                        {...rProps}
                        id={name}
                        options={options}
                        getOptionLabel={getOptionLabel}
                        loading={loading}
                        disabled={disabled}
                        renderInput={params => (
                            <TextField
                                {...params}
                                label={boxtext}
                                variant='outlined'
                                InputProps={{
                                    ...params.InputProps,
                                    'data-cy': `form-field-${toSnakeCase(
                                        name
                                    )}`,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading ? (
                                                <CircularProgress
                                                    color='inherit'
                                                    size={20}
                                                />
                                            ) : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                        onChange={(_, data) => {
                            rProps.onChange(data);
                            onChangeListener?.(data);
                        }}
                    />
                )}
                name={name}
                control={control}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
};

export default AutocompleteSelect;
